<app-view-title Title="Ready to roll!" [isSplitColor]="true"></app-view-title>
<view-content [centered]="true">
  <app-information-screen [centered]="true"
                          image="/assets/Images/big-checkbox-green.png"
                          title="{{ 'Intellitrailer.Rental.PickupComplete.Title' | translate : 'Pickup Completed!' }}"
                          primaryContent="{{ 'Intellitrailer.Rental.PickupComplete.Ready' | translate : 'You have now successfully started your rent.' }}"
                          secondaryContent="{{ 'Intellitrailer.Rental.PickupComplete.NextStep' | translate : 'You are all set and can continue when you are ready.' }}">
  </app-information-screen>
</view-content>
<view-actions mode ="white">
  <button mat-raised-button (click)="next()">{{ 'Intellitrailer.Rental.PickupComplete.cmdNext' | translate : 'Ok! Let´s go!' }}</button>
</view-actions>

